import { v4 as uuidv4 } from 'uuid';
export function createDefaultTaskSummary() {
    return {
        completed_count: 0,
        completed_tasks: [],
        stale_count: 0,
        stale_tasks: [],
        upcoming_deadlines: [],
        total_time_spent: 0,
    };
}
export function createDefaultReviewContent() {
    return {
        tasks_completed: createDefaultTaskSummary(),
        goals_progress: [],
        habits_summary: [],
        lists_summary: [],
        productivity_score: 0,
        highlights: [],
        areas_for_improvement: [],
    };
}
export function createReview(reviewType, date, periodStart, periodEnd) {
    return {
        id: uuidv4(),
        review_type: reviewType,
        date,
        period_start: periodStart,
        period_end: periodEnd,
        content: createDefaultReviewContent(),
        notes: '',
        created_at: new Date().toISOString(),
    };
}
//# sourceMappingURL=review.js.map